var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_55532",
    "data-name": "Group 55532",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.247,
    height: 48.247,
    viewBox: "0 0 48.247 48.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_85350",
    "data-name": "Path 85350",
    d: "M309.894,302a9.894,9.894,0,1,0,0,19.789,9.9,9.9,0,1,0,0-19.789Zm2.827,11.308h-2.827a1.413,1.413,0,0,1-1.413-1.414v-2.827a1.413,1.413,0,0,1,2.827,0v1.414h1.414a1.413,1.413,0,0,1,0,2.827Z",
    transform: "translate(-271.73 -273.542)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85351",
    "data-name": "Path 85351",
    d: "M5.654,377H2.827a2.827,2.827,0,1,0,0,5.654H5.654a2.827,2.827,0,1,0,0-5.654Z",
    transform: "translate(0 -341.474)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85352",
    "data-name": "Path 85352",
    d: "M5.654,227H2.827a2.827,2.827,0,1,0,0,5.654H5.654a2.827,2.827,0,1,0,0-5.654Z",
    transform: "translate(0 -205.609)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85353",
    "data-name": "Path 85353",
    d: "M5.654,75H2.827a2.827,2.827,0,0,0,0,5.654H5.654a2.827,2.827,0,0,0,0-5.654Z",
    transform: "translate(0 -67.933)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85354",
    "data-name": "Path 85354",
    d: "M95.337,0H64.24A4.245,4.245,0,0,0,60,4.24a5.654,5.654,0,1,1,0,11.308v3.015a5.654,5.654,0,1,1,0,11.308V32.7a5.654,5.654,0,1,1,0,11.308,4.245,4.245,0,0,0,4.24,4.24H84.613a12.668,12.668,0,0,1,7.9-22.616,13.266,13.266,0,0,1,7.256,2.153V4.24A4.41,4.41,0,0,0,95.337,0ZM79.375,30.871l-5.654,5.654a1.413,1.413,0,0,1-2,0L68.5,33.3a1.413,1.413,0,1,1,2-2l2.225,2.225,4.655-4.655a1.413,1.413,0,0,1,2,2Zm0-11.308-5.654,5.654a1.413,1.413,0,0,1-2,0L68.5,21.993a1.413,1.413,0,1,1,2-2l2.225,2.225,4.655-4.655a1.413,1.413,0,1,1,2,2Zm0-11.5-5.654,5.654a1.413,1.413,0,0,1-2,0L68.5,10.5a1.413,1.413,0,1,1,2-2l2.225,2.225,4.655-4.655a1.413,1.413,0,0,1,2,2ZM92.51,22.8H84.029a1.413,1.413,0,0,1,0-2.827H92.51a1.413,1.413,0,0,1,0,2.827Zm0-11.5H84.029a1.413,1.413,0,0,1,0-2.827H92.51a1.413,1.413,0,0,1,0,2.827Z",
    transform: "translate(-54.346)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgram);
export default __webpack_public_path__ + "static/media/program.b73d0e6a0727ac78b9e9cf3ddb237ffa.svg";
export { ForwardRef as ReactComponent };